const fileTypesMap = {
  "special offer": "Спецпредложения",
  partner: "Партнеры",
  "partner card": "Партнеры карты",
  "partner category": "Партнеры категории",
  "partner step": "Партнеры шаги",
  "partner promotion": "Партнеры акции",
  "campaign image": "Изображение акции",
  "campaign image (large)": "Изображение акции (большое)",
  "barclub promotion": "Барный клуб акции",
  document: "Документ",
  report: "Отчет",
  other: "Другие",
};

export const enumUserRoles = [
  {
    id: "admin",
    name: "Aдминистратор",
  },
  {
    id: "adminregion",
    name: "Администратор Региона",
  },
  {
    id: "admintrade",
    name: "Aдминистратор Трейд Р",
  },
  {
    id: "adminsales",
    name: "Администратор ТП/SV",
  },
  {
    id: "sales",
    name: "Торговый представитель",
  },
  {
    id: "supervisor",
    name: "SV",
  },
  {
    id: "ldfd",
    name: "LD/FD",
  },
  {
    id: "traderegion",
    name: "Трейд Р",
  },
  {
    id: "trademacro",
    name: "Трейд МР",
  },
  {
    id: "merchmacro",
    name: "Мерч МР",
  },
  {
    id: "tradecentral",
    name: "Трейд ЦФ",
  },
  {
    id: "lca",
    name: "LCA",
  },
  {
    id: "contractor",
    name: "Подрядчик",
  },
];
export const enumUserRolesAdminRegion = [
  {
    id: "sales",
    name: "Торговый представитель",
  },
  {
    id: "supervisor",
    name: "SV",
  },
  {
    id: "ldfd",
    name: "LD/FD",
  },
  {
    id: "traderegion",
    name: "Трейд Р",
  },
  {
    id: "trademacro",
    name: "Трейд МР",
  },
  {
    id: "merchmacro",
    name: "Мерч МР",
  },
  {
    id: "tradecentral",
    name: "Трейд ЦФ",
  },
  {
    id: "lca",
    name: "LCA",
  },
  {
    id: "contractor",
    name: "Подрядчик",
  },
];

export const enumAuditEvents = [
  {
    id: "login_success",
    name: "Успешная авторизация",
  },
  {
    id: "login_fail",
    name: "Неудачная попытка входа",
  },
  {
    id: "password_change",
    name: "Смена пароля",
  },
  {
    id: "temp_password_assigned",
    name: "Сгенерирован временный пароль",
  },
  {
    id: "block_temporary",
    name: "Учетная запись временно заблокирована",
  },
  {
    id: "block_permanent",
    name: "Полная блокировка учетной записи",
  },
  {
    id: "password_expired_login_attempt",
    name: "Попытка входа с устаревшим паролем",
  },
];

export const enumRequestState = [
  {
    id: "new",
    name: "Новая",
  },
  {
    id: "prepare",
    name: "Подготовка кейса",
  },
  {
    id: "negotiate",
    name: "Согласование",
  },
  {
    id: "review",
    name: "Согласование ЦФ",
  },
  {
    id: "work",
    name: "В работе",
  },
  {
    id: "report",
    name: "Требуется фотоотчет",
  },
  {
    id: "check",
    name: "Проверка отчета",
  },
  {
    id: "closed",
    name: "Закрыта",
  },
  {
    id: "suspended",
    name: "Приостановленна",
  },
  {
    id: "canceled",
    name: "Отклонена",
  },
];

const collections = {
  type(value) {
    return fileTypesMap[value];
  },
  image_type(value) {
    return fileTypesMap[value];
  },
  file_type(value) {
    return fileTypesMap[value];
  },
  state_type(value) {
    const state = enumRequestState.find((r) => r.id == value);
    return state ? state.name : value;
  },
  role_type(value) {
    const role = enumUserRoles.find((r) => r.id == value);
    return role ? role.name : value;
  },
  channels_type(value) {
    const map = {
      federal: "Федеральный канал",
      local: "Локальный канал",
    };
    return map[value];
  },
  video_type(value) {
    const map = {
      0: "Онлайн-экскурсии",
      1: "Лекции",
    };
    return map[value];
  },
  eduLvl(value) {
    const map = {
      undergraduate: "Бакалавриат",
      magistracy: "Магистратура",
      postgraduate: "Специалитет",
    };
    return map[value];
  },
  eduForm(value) {
    const map = {
      "full-time": "Очная",
      "part-time": "Очно-заочная",
      mixed: "Заочная",
    };
    return map[value];
  },
  subdivision(value) {
    const map = {
      faculty: "Факультет",
      institute: "Институт",
      school: "Школа",
      other: "Другое",
    };
    return map[value];
  },
  status(value) {
    const map = {
      new: "Новая",
      accepted: "Одобрена",
      declined: "Отклонена",
    };
    return map[value];
  },
  bugStatus(value) {
    const map = {
      true: "Обработана",
      false: "Новая",
    };
    return map[value];
  },
  audit_type(value) {
    const event = enumAuditEvents.find((e) => e.id == value);
    return event ? event.name : value;
  },
};

export function enumFilter(name, value) {
  if (typeof collections[name] === "function") {
    return collections[name](value) || value;
  }
  return value;
}

export function getValuesForTableColumnFilter(type) {
  const values = [];
  if (type === "file") {
    for (const value in fileTypesMap) {
      if (Object.hasOwnProperty.call(fileTypesMap, value)) {
        values.push({ value: value, text: fileTypesMap[value] });
      }
    }
  }
  return values;
}
